import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddRowBefore = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.49994 2C8.49994 1.72386 8.27608 1.5 7.99994 1.5C7.7238 1.5 7.49994 1.72386 7.49994 2V4.5L4.99994 4.5C4.7238 4.5 4.49994 4.72386 4.49994 5C4.49994 5.27614 4.7238 5.5 4.99994 5.5H7.49994V8C7.49994 8.27614 7.7238 8.5 7.99994 8.5C8.27608 8.5 8.49994 8.27614 8.49994 8V5.5H10.9999C11.2761 5.5 11.4999 5.27614 11.4999 5C11.4999 4.72386 11.2761 4.5 10.9999 4.5L8.49994 4.5V2ZM4.5 11H2.5L2.5 13H4.5V11ZM4.5 10H5.5H7.5H8.5H10.5H11.5H13.5C14.0523 10 14.5 10.4477 14.5 11V13C14.5 13.5523 14.0523 14 13.5 14H11.5H10.5H8.5H7.5H5.5H4.5H2.5C1.94772 14 1.5 13.5523 1.5 13V11C1.5 10.4477 1.94772 10 2.5 10H4.5ZM11.5 13H13.5V11H11.5V13ZM10.5 11V13H8.5V11H10.5ZM5.5 11H7.5V13H5.5V11Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AddRowBefore
